export type NotificationType =
  | "order"
  | "cancelled"
  | "review"
  | "negative"
  | "settlement"
  | "fine";

export interface Notification {
  id: number;
  type: NotificationType;
  title: string;
  message: string;
  time: string;
  read: boolean;
}

export const notifications: Notification[] = [
  {
    id: 1,
    type: "order",
    title: "طلب جديد",
    message: "وصل طلب جديد GH-2847 — تنظيف منزل، 3 غرف وصالة، حي النرجس",
    time: "منذ 5 دقائق",
    read: false,
  },
  {
    id: 2,
    type: "negative",
    title: "تقييم سلبي (2★)",
    message: "حصلت على تقييم 2★ من عميل على خدمة غسيل السيارات — ننصح بالرد بسرعة",
    time: "منذ ساعة",
    read: false,
  },
  {
    id: 3,
    type: "settlement",
    title: "تسوية مالية جاهزة",
    message: "تسوية شهر يوليو جاهزة — الصافي 3,230 ر.س وسيتم التحويل خلال الدورة القادمة",
    time: "منذ 3 ساعات",
    read: false,
  },
  {
    id: 4,
    type: "cancelled",
    title: "طلب ملغي",
    message: "تم إلغاء الطلب GH-2839 من قبل العميل قبل وصول الفريق",
    time: "أمس، 6:40 م",
    read: true,
  },
  {
    id: 5,
    type: "review",
    title: "تقييم جديد (5★)",
    message: "حصلت على تقييم 5★ من عميل على خدمة تنظيف المنازل",
    time: "أمس، 2:15 م",
    read: true,
  },
  {
    id: 6,
    type: "fine",
    title: "غرامة تأخير",
    message: "تم خصم غرامة 50 ر.س بسبب تأخر وصول الفريق 30 دقيقة على الطلب GH-2831",
    time: "أمس، 11:05 ص",
    read: true,
  },
  {
    id: 7,
    type: "order",
    title: "طلب جديد",
    message: "وصل طلب جديد GH-2830 — غسيل سيارة خارجي وداخلي، حي الياسمين",
    time: "14 أغسطس، 8:20 م",
    read: true,
  },
  {
    id: 8,
    type: "review",
    title: "تقييم جديد (4★)",
    message: "حصلت على تقييم 4★ من عميل على خدمة غسيل السيارات",
    time: "14 أغسطس، 1:40 م",
    read: true,
  },
  {
    id: 9,
    type: "settlement",
    title: "تسوية مالية محدثة",
    message: "تم تحديث تسوية شهر يونيو بعد إلغاء غرامة — الصافي الجديد 2,940 ر.س",
    time: "13 أغسطس، 4:10 م",
    read: true,
  },
  {
    id: 10,
    type: "cancelled",
    title: "طلب ملغي",
    message: "تم إلغاء الطلب GH-2825 بسبب تعذر الوصول لعنوان العميل",
    time: "12 أغسطس، 7:55 م",
    read: true,
  },
];

export const notificationFilters = [
  { key: "all", label: "الكل" },
  { key: "order", label: "الطلبات" },
  { key: "review", label: "التقييمات" },
  { key: "settlement", label: "التسويات" },
  { key: "fine", label: "الغرامات" },
] as const;

export type NotificationFilterKey = (typeof notificationFilters)[number]["key"];